import { Listbox, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import { FaChevronUp } from 'react-icons/fa6'
import { GoDotFill } from 'react-icons/go'

export default function PageSizeSelectBox({ selected, setSelected, setPage }) {
    return (
        <Listbox value={selected} onChange={(number) => { if (selected !== number) { setSelected(number); setPage(1); } }} >
            <div className="relative">
                <Listbox.Button className="relative w-[80px] cursor-pointer rounded-lg bg-white h-10 pl-3 pr-5 text-left border border-gray-400 sm:text-sm">
                    <div className="truncate">{selected}</div>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <FaChevronUp />
                    </span>
                </Listbox.Button>
                <Transition
                    as={Fragment}
                    leave="transition ease duration-200"
                    leaveFrom=" opacity-100"
                    leaveTo=" opacity-0"
                    enterFrom=' opacity-0'
                    enterTo=' opacity-100'
                    enter="transition ease duration-200"
                >
                    <Listbox.Options className="-top-1 transform -translate-y-full absolute right-0 w-full origin-top-right bg-white divide-y divide-gray-300 rounded-lg shadow-lg ring-2 ring-slate-300">
                        {[5, 10, 20, 50, 100].map((person, personIdx) => (
                            <Listbox.Option
                                key={personIdx}
                                className={({ active }) => `relative cursor-pointer select-none py-2 pl-7 pr-4 ${active ? 'bg-yellow1/50 text-amber-900' : 'text-gray-900'}`
                                }
                                value={person}
                            >
                                {({ selected }) => (
                                    <>
                                        <span
                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                }`}
                                        >
                                            {person}
                                        </span>
                                        {selected ? (
                                            <span className="absolute inset-y-0 left-0 flex items-center pl-1.5 text-hotPink">
                                                <GoDotFill className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                        ) : null}
                                    </>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}
